<template>
  <div
    :class="$style.base"
    :style="baseStyle"
  >
    <div :class="$style.message">
      <BaseText v-test="'previewDiscountMessage'">
        {{ discountMessage
            ? discountMessage
            : $t('marketing.email.preview.discount_message_default') }}
      </BaseText>
    </div>
    <div
      :class="$style.code"
      :style="opacityStyle"
      v-test="'previewDiscountCode'"
    >
      {{ discount && discount.code
          ? discount.code
          : $t('marketing.email.preview.discount_code_default') }}
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useMarketingStore } from '../../../store';

const { discountMessage, discount, color } = storeToRefs(useMarketingStore());
const baseStyle = computed(() => {
  return `border-color: ${color.value}; color: ${color.value};`;
});
const opacityStyle = computed(() => {
  return `background-color: ${color.value}10;`;
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: $spacing * 1.5;
  border: 1px dashed var(--color-warning);
  color: var(--color-warning);
}

.code {
  background: var(--color-warning-light);
  padding: $spacing;
}

.message {
  margin-right: $spacing;
}
</style>
